import { FC } from 'react';
import { IRTERenderElementProps } from '../../../../RTEEditable.interfaces';

export const DefaultElement: FC<IRTERenderElementProps> = (props) => {
  const { element, children } = props;
  const attributes = props.attributes ?? {};

  return (
    <p
      {...element.attr}
      {...attributes}
      style={{
        margin: 0,
        minHeight: '18px',
      }}
    >
      {children}
    </p>
  );
};
